import type { SimpleTaskType, TaskType } from 'models/task';

export const isTaskTypeSimple = (type?: TaskType): type is SimpleTaskType => {
  return type === 'reports' || type === 'ts';
};
